const isOldOrderFormat = (orderDetails) => {
    return 'marketSegment' in orderDetails;
};

const PRODUCT_PROCESSORS = {
    TERMINALS: ({ terminals, marketSegment, planName, paymentType }) => {
        const items = [];
        if (terminals) {
            terminals.forEach((t) => {
                const productCategory = t.productCategory
                    ? t.productCategory.match(/Smartfony/)
                        ? 'Smartfony'
                        : 'Urządzenie'
                    : 'Urządzenie';
                const item = {
                    eci_category_aggr: `WWW/${marketSegment}/${planName}/Nowy/${productCategory}`,
                    item_name: t.name,
                    item_variant: t.productCode,
                    eci_payment_type: paymentType
                };
                items.push(item);
            });
        }
        return items;
    },
    EUROSETS: () => {
        // TODO
    },
    VASES: ({ vases, marketSegment, planName, paymentType }) => {
        const items = [];
        if (vases) {
            vases.forEach((v) => {
                const item = {
                    eci_category_aggr: `WWW/${marketSegment}/${planName}/Nowy/VAS`,
                    item_name: v.name,
                    item_id: v.productCode,
                    eci_payment_type: paymentType
                };
                items.push(item);
            });
        }
        return items;
    }
};

const ORDER_ENTRY_PROCESSORS = {
    INSTALMENT_SALES_OF_GOODS: (entry) => {
        const items = [];
        items.push(
            ...PRODUCT_PROCESSORS['TERMINALS']({
                terminals: entry.terminals,
                marketSegment: entry.bundleCode.includes('B2B') ? 'B2B' : 'B2C',
                planName: 'Telefony_i_urządzenia',
                paymentType: 'RATY'
            })
        );
        return items;
    },
    ACTIVATION: (entry, marketSegment = 'B2C') => {
        const items = [];
        const processEntry = (e) => {
            const items = [];
            const planName = e.planName
                .replaceAll(' ', '_')
                .replace('Abonament_komórkowy', 'Plany_abonamentowe');
            items.push({
                eci_category_aggr: `WWW/${marketSegment}/${planName}`,
                item_name: e.planName,
                item_variant: e.productCode,
                eci_payment_type: 'ABONAMENT'
            });
            items.push(
                ...PRODUCT_PROCESSORS['TERMINALS']({
                    terminals: e.terminals,
                    marketSegment: marketSegment,
                    planName: planName,
                    paymentType: 'ABONAMENT'
                })
            );
            items.push(
                ...PRODUCT_PROCESSORS['VASES']({
                    vases: e.vases,
                    marketSegment: marketSegment,
                    planName: planName,
                    paymentType: 'ABONAMENT'
                })
            );
            return items;
        };
        switch (entry.bundleType) {
            case 'HARDBUNDLE':
                {
                    if (entry.entries) {
                        entry.entries.forEach((e) => {
                            items.push(...processEntry(e));
                        });
                    }
                }
                break;
            case 'VOICE':
                {
                    items.push(...processEntry(entry));
                }
                break;
        }
        return items;
    }
};

const getItems = (orderDetails) => {
    let items = [];
    orderDetails.entries.forEach((e) => {
        const processor = ORDER_ENTRY_PROCESSORS[e.processType];
        if (processor) {
            items.push(
                ...processor(
                    e,
                    orderDetails.marketSegment ? orderDetails.marketSegment.toUpperCase() : null
                )
            );
        } else {
            items.push({
                eci_payment_type: 'CASH'
            });
        }
    });
    return items;
};

const transformOldOrder = (orderDetails) => {
    if (!isOldOrderFormat(orderDetails)) {
        return orderDetails;
    }
    return {
        items: getItems(orderDetails)
    };
};

export { transformOldOrder };
